import { OngewensteGebeurtenis } from "@/entities/ongewenste-gebeurtenis";
import { Omschrijvingen, ReikwijdtePicker } from "../shared";
import { OngewensteGebeurtenisSummaryCard } from "../shared/ongewenste-gebeurtenis-summary-card.tsx";

type SpoorwebStepProps = {
    currentSpoorwebItem: OngewensteGebeurtenis | undefined;
};

export function SpoorwebStep({ currentSpoorwebItem }: Readonly<SpoorwebStepProps>) {
    const isClosed = currentSpoorwebItem?.meldingStatus === "Gesloten";

    return (
        <div className="grid gap-4 p-6 pb-8">
            <OngewensteGebeurtenisSummaryCard
                key={currentSpoorwebItem?.volgnummer}
                ongewensteGebeurtenis={currentSpoorwebItem}
                betrokkenTreinen={currentSpoorwebItem?.betrokkenTreinen}
                spoorwebStatus={currentSpoorwebItem?.meldingStatus}
            />
            <fieldset disabled={isClosed}>
                <div className="grid gap-4">
                    <Omschrijvingen />
                    <ReikwijdtePicker />
                </div>
            </fieldset>
        </div>
    );
}
